//import styled from 'styled-components';
import styled, { css } from 'styled-components';

import {
  colors,
  layers,
  typography,
} from '../../theme';

import {
  TextSmall,
  HeadingTwo,
  HeadingOneCentered,
} from '../../elements';

export const Wrapper = styled.div`
  left: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  position: fixed;
  -webkit-backface-visibility: hidden;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  background: ${colors.GREY_WHITE};
  z-index: ${layers.FOOTER};

  ${(props) => props.position === 'opacity-full' && css`
    display: block;
  `}

  ${(props) => props.position === 'opacity-zero' && css`
    display: none;
  `}

`;

export const Share = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  margin: ${10 / typography.BASE_FONT_SIZE}rem;
  ${typography.BODY__SMALL}
  border: 1px solid ${colors.BLACK};
  display: none;
`;

export const Icon = styled.div`
  float: left;
  &:nth-child(1) {
    border-right: 1px solid ${colors.BLACK};
  }
  &:nth-child(2) {
    border-right: 1px solid ${colors.BLACK};
  }
`;

export const SignOff = styled.div`
  left: 0;
  padding: 1.5rem;
  position: absolute;
  top: 0;

  a {
    color: ${colors.BLACK};
    text-decoration: underline;
  }
`;

export const HelpShape = HeadingTwo.extend`
  position: absolute;
  left: 25%;
  width: 50%;
  //z-index: 9;
  text-align: center;
  top: ${8 / typography.BASE_FONT_SIZE}rem;
  a {
    color: #000;
  }

  @media screen and (max-width: 666px) {
    ${typography.SUB_HEADING_MOBILE};
    left: 38%;
    width: 62%;
    margin-top: ${15/typography.BASE_FONT_SIZE}rem !important;
  }

`;

export const HeadingOneCenteredSpecial = HeadingOneCentered.extend`
  @media screen and (max-width: 666px) {
    margin: 0;
    padding-left: ${100/typography.BASE_FONT_SIZE}rem;
    padding-right: ${100/typography.BASE_FONT_SIZE}rem;
    //background: cyan;
  }
`;

export const Credits = TextSmall.extend`
  position: absolute;
  left: 0;
  bottom: 0;
  margin: ${6 / typography.BASE_FONT_SIZE}rem  ${10 / typography.BASE_FONT_SIZE}rem;
  ${typography.BODY__SMALL}

  @media all and (max-width: 1023px) and (min-width: 667px) {

  }

  @media screen and (max-width: 666px) {
    margin: 0;
    padding: ${13/typography.BASE_FONT_SIZE}rem;
    padding-bottom: ${9/typography.BASE_FONT_SIZE}rem;
    //text-align: center;
    width: 100%;
  }

`;

export const SectionTrending = styled.section`
  position: relative;
`;



// WEBPACK FOOTER //
// ./src/components/Footer/style.js